module.exports = __webpack_public_path__ + "img/logo.95602020.svg";